// ** MUI Imports
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const FooterContent = () => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-end',height: '100%',           // take parent height
     }}>
      <Typography sx={{ mr: 2 }}>
        {`© ${new Date().getFullYear()} All Rights Reserved Totient Business Solutions Inc. `}
      </Typography>
    </Box>
  )
}

export default FooterContent
